import { useState } from "react";
import { Text, Box, useThemeUI } from "theme-ui";

import Button from "components/Button";
import { CheckmarkIcon } from "components/icons";
import * as styles from "./PerformanceOptions.styles";

export default function PerformanceOptionField({
  isSelected,
  option,
  heading,
  subHeading1,
  subHeading2,
  bladeSegments = [],
  value,
  onChange,
}) {
  const [dotSelected, setDotSelected] = useState(
    bladeSegments[0]?.description || ""
  );

  const {
    theme: { isMobile },
  } = useThemeUI();

  return (
    <Box sx={styles.optionContainerOuter({ isMobile })}>
      <Box sx={styles.optionContainerInner({ isSelected })}>
        <Text sx={styles.heading} variant="h4Light">
          {heading}
        </Text>
        <Text sx={styles.subHeading} variant="copy2">
          {subHeading1}
        </Text>
        <Text sx={styles.subHeading2} variant="copy2Light">
          {subHeading2}
        </Text>
        <Box sx={styles.image(option?.image)}>
          {bladeSegments.map((segment) => {
            const isDotSelected = dotSelected === segment.description;
            return (
              <Box
                key={segment.label}
                sx={styles.dot({ position: segment.position, isDotSelected })}
                onClick={() => {
                  setDotSelected(segment.description);
                }}
              ></Box>
            );
          })}
        </Box>

        <Text as="div" sx={styles.bladeSegmentDescription} variant="copy3">
          {dotSelected}
        </Text>

        <Button
          variant="secondary"
          size="medium"
          theme="dark"
          isRound
          isSelected={isSelected}
          iconBefore={isSelected && <CheckmarkIcon />}
          onClick={() => {
            onChange(value);
          }}
        >
          {value}
        </Button>
      </Box>
    </Box>
  );
}
